import React from 'react';
import { SectionHeader } from './ui/SectionHeader';
import { CtaBlock } from './ui/CtaBlock';
import { PRODUCT_NAME, tomos } from '../data/content';
export function SolutionSection() {
  return <section aria-labelledby="solucion" className="bg-white" data-id="element-130" data-mp="3o9trxz6mahzz">
      <div className="mx-auto max-w-3xl px-3 py-5 sm:px-4 sm:py-8" data-id="element-131" data-mp="3o77mq6778ekx">
        <SectionHeader id="solucion" eyebrow="La solución que estabas buscando — un sistema 6 en 1" title="6 tomos en un solo sistema, creados para aprender desde cero." data-id="element-132" data-mp="3j9fpqxrp629v" />
        <p className="mt-2 text-center text-[0.82rem] font-extrabold text-wifi sm:text-base" data-id="element-133" data-mp="3t7vif56dhjlh">📡 {PRODUCT_NAME}</p>
        <p className="mx-auto mt-1 max-w-2xl text-center text-[0.82rem] leading-snug text-negro/75 sm:text-sm" data-id="element-134" data-mp="awi8qbov3njd">
          No es simplemente otro ebook técnico. Es una ruta de aprendizaje que
          organiza los conocimientos fundamentales para que comprendas qué
          aprender primero, qué viene después y cómo se relacionan los
          diferentes componentes de una red.
        </p>

        <ol className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-135" data-mp="36cp0co83jnh4">
          {tomos.map((tomo, i) => <li key={tomo.title} className="flex gap-2.5 rounded-xl border border-navy/10 bg-gris p-2.5 sm:p-3" data-id="element-136" data-mp="3b9yxkq1q93fi" data-mpi={i}>
              <span className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-lg bg-navy font-display text-lg text-amarillo" data-id="element-137" data-mp="3fdn6bc23i52c">
                {i + 1}
              </span>
              <div data-id="element-138" data-mp="3p984t07ygn7c">
                <p className="text-[0.68rem] font-bold uppercase text-wifi" data-id="element-139" data-mp="3u8kzu88zd0l0">Tomo {i + 1}</p>
                <h3 className="text-[0.82rem] font-extrabold leading-tight text-navy sm:text-sm" data-id="element-140" data-mp="3u68a38wzdlxe">{tomo.title}</h3>
                <p className="mt-0.5 text-[0.78rem] leading-snug text-negro/75 sm:text-sm" data-id="element-141" data-mp="6vh72hu6mf76">{tomo.desc}</p>
              </div>
            </li>)}
        </ol>

        <CtaBlock note="" data-id="element-142" data-mp="bweqexqxhfa9" />
      </div>
    </section>;
}